import { useI18n } from "@/lib/i18n";
import { cn } from "@/lib/utils";

export function DiscountBadge({
  price,
  originalPrice,
  className,
}: {
  price: number;
  originalPrice?: number | null | undefined;
  className?: string;
}) {
  const { t } = useI18n();
  if (originalPrice == null || originalPrice <= price) return null;
  const percent = Math.max(1, Math.round(((originalPrice - price) / originalPrice) * 100));
  return (
    <span
      className={cn(
        "absolute end-2 top-2 z-10 rounded-full bg-destructive px-2.5 py-1 text-xs font-extrabold leading-none text-destructive-foreground shadow-sm sm:end-3 sm:top-3",
        className,
      )}
    >
      {t("menu.discountBadge", { percent })}
    </span>
  );
}
